import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { assignment_api } from '@axo/shared/data-access/api';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { userKeys } from '../../cache-keys/userKeys';
import { assignment } from '@axo/shared/data-access/types';

export function useUpdateAvailability(country: string) {
  const {
    state: {
      user: { clientID },
    },
  } = useContext(DataAccessContext);
  const api = useAPI();
  const client = useQueryClient();
  return useMutation(
    (availability: assignment.AvailabilityStatus) =>
      assignment_api.putAssignee(api)({
        country: country,
        user: clientID,
        input: {
          AvailabilityStatus: availability,
        },
      }),
    {
      onSuccess: (assignee) =>
        client.invalidateQueries(
          userKeys.assignee({
            user: clientID,
            country: assignee.Country,
          })
        ),
    }
  );
}
